module.exports = __webpack_public_path__ + "static/media/Buy.a6d57c8b.svg";